
<app-enfaf-modal
  svgIcon="school"
  [title]="'¡Has finalizado el curso!'"
  [buttonCancelText]="'Cerrar'"
  [buttonConfirmText]="'Quiero mi diploma'"
  (onClose)="closeModal()"
  (onConfirm)="goToWhatsapp()"
  [showConfirmButton]="data.sendDiploma"
  >
  @if (freeCourseCompleted) {
    <p>
      ¡Enhorabuena por haber completado este curso! Ahora estás a sólo un paso de convertirte en un experto en biomecánica, el sector del
      entrenamiento personal es de los que más crece y es sumamente importante destacar del resto.
    </p>
  } @else {
    <p>¡Enhorabuena por haber completado este curso!</p>
  }
</app-enfaf-modal>